import { ModelCategory, ScheduleLineGroup } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties';
import { GroupedProductionComponentInstanceSchema } from './GroupedProductionComponentInstanceSchema';

export const ScheduleLineGroupSchema = new ModelSchema<ScheduleLineGroup>('scheduleLineGroup', {
  category: ModelCategory.IntermediateModel,

  children: {
    components: GroupedProductionComponentInstanceSchema,
  },

  properties: {
    guid: StringProperty.configure({ readOnly: true }),
  },
});
